import React from 'react';

export const HeartBubbleIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            {...props}
        >
            <path
                d="M.667 7.046C.667 3.478 3.997.666 8 .666c4.002 0 7.333 2.812 7.333 6.38 0 3.567-3.33 6.378-7.333 6.378-.837 0-1.67-.127-2.471-.377l-3.75 2.24a.333.333 0 01-.48-.41l1.372-3.442a5.863 5.863 0 01-1.403-1.854 6.098 6.098 0 01-.601-2.529v-.006z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.3 7.05C1.302 3.928 4.266 1.3 8.05 1.3c3.785 0 6.75 2.63 6.75 5.753s-2.965 5.753-6.75 5.753a7.75 7.75 0 01-2.44-.395.296.296 0 00-.245.027L2.236 14.3l1.127-2.815a.328.328 0 00-.096-.376A5.224 5.224 0 011.841 9.31 5.443 5.443 0 011.3 7.05z"
                fill="#F7F7F7"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.765 4.73a1.3 1.3 0 00-1.317 2.155l.005.005 2.52 2.628 2.523-2.633a1.3 1.3 0 00-1.838-1.838l-.45.45c-.13.13-.341.13-.471.001l-.452-.45a1.301 1.301 0 00-.52-.319zm4.57.357a1.966 1.966 0 01-.365 2.267L8.213 10.23a.333.333 0 01-.482 0L4.975 7.354a1.965 1.965 0 01-.368-2.267m6.728 0a1.965 1.965 0 00-3.148-.511l-.215.215-.216-.215a1.967 1.967 0 00-3.149.511"
                fill="currentColor"
            />
        </svg>
    );
};
